export function ValidaId(numDoc, pais) {
    switch (pais.toLowerCase()) {
        case "br":
            switch (numDoc.length) {
                case 11:
                    return true
                case 14:
                    return true
                default:
                    return false
            }
        default:
            return true;
    }
}

export function mascaraCNPJ(v) {
    v = v.replace(/\D/g, "")                           //Remove tudo o que não é dígito
    v = v.replace(/^(\d{2})(\d)/, "$1.$2")             //Coloca ponto entre o segundo e o terceiro dígitos
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3") //Coloca ponto entre o quinto e o sexto dígitos
    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2")           //Coloca uma barra entre o oitavo e o nono dígitos
    v = v.replace(/(\d{4})(\d)/, "$1-$2")              //Coloca um hífen depois do bloco de quatro dígitos
    return v
}

export function mascaraCPF(v) {
    v = v.replace(/\D/g, "")                    //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, "$1.$2")       //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, "$1.$2")       //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2") //Coloca um hífen entre o terceiro e o quarto dígitos
    return v
}

export function mascaraDocCO(v) {
    v = v.replace(/\D/g, "")                    //Remove tudo o que não é dígito
    v = v.replace(/(\d{5})(\d)/, "$1 $2")       //Coloca um espaço entre o quinto e o sexto dígitos
    return v
}

export function mascaraValorReal(v) {
    return v.toLocaleString('pt-br', { minimumFractionDigits: 2 });
}

export function mascaraValorEmReal(v) {
    if (v === undefined) {
        return ""
    }
    v = v.replace(/\D/g, "");                   //Remove tudo o que não é dígito
    v = v.substring(0, 8);                       //Remove tudo além dos 8 dígitos
    //Coloca uma virgula entre centavos e reais
    let tam = v.length
    if (tam > 5) {
        v = v.replace(/(\d)(\d{5})$/, "$1.$2");      //Coloca um ponto entre centena e milhar
        if (v.substring(0, 1) === "0") v = v.replace(/0/, "");
    }
    if (tam > 2) {
        v = v.replace(/(\d)(\d{2})$/, "$1,$2");           //Remove tudo o que não é dígito
        if (v.substring(0, 2) === "00") v = v.replace(/00/, "0");
        if (v.length === 5 && v.substring(0, 1) === "0") v = v.replace(/0/, "");
    } else if (tam === 2) {
        v = "0," + v
    } else {
        v = "0,0" + v
    }
    return v
}

export function mascaraStringToDouble(v) {
    v = v.replace(/\D/g, "");
    switch (v.length) {
        case 1:
            v = "0.0" + v
            break;
        case 2:
            v = "0." + v
            break;
        default:
            v = v.replace(/(\d)(\d{2})$/, "$1.$2");
            break;
    }
    return parseFloat(v);
}

export function validaCpf(strCPF) {
    let Soma;
    let Resto;
    Soma = 0;
    if (strCPF === "00000000000" ||
        strCPF === "11111111111" ||
        strCPF === "22222222222" ||
        strCPF === "33333333333" ||
        strCPF === "44444444444" ||
        strCPF === "55555555555" ||
        strCPF === "66666666666" ||
        strCPF === "77777777777" ||
        strCPF === "88888888888" ||
        strCPF === "99999999999") {
        return false;
    }

    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
}

export function validaCnpj(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj === '') return false;

    if (cnpj.length !== 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj === "00000000000000" ||
        cnpj === "11111111111111" ||
        cnpj === "22222222222222" ||
        cnpj === "33333333333333" ||
        cnpj === "44444444444444" ||
        cnpj === "55555555555555" ||
        cnpj === "66666666666666" ||
        cnpj === "77777777777777" ||
        cnpj === "88888888888888" ||
        cnpj === "99999999999999") {
        return false;
    }

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado.toString() !== digitos.charAt(0).toString())
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado.toString() !== digitos.charAt(1).toString())
        return false;

    return true;
}

